module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/clickworker/briefing_de-eaba56a731203d9d1f71b20dcc33c172.gif";